import React from 'react';
import { IResortPageSnowInfo } from '@/api/resort/types';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { openCountText, runsOpenPercent } from '@/util/openCount';
import { MiniSectionHeading, StatBlock } from './atoms';

export const LiftsTerrain = ({ fullResort }: { fullResort: IResortPageSnowInfo }) => {
  const { t } = useOTSTranslation('common');
  const dash = t('common.dash');
  const hasLifts = !!fullResort.lifts?.total;
  const hasRuns = !!fullResort.runs?.total;
  const hasAcres = !!fullResort.terrain?.acres?.open;
  // Unreported counts come back as null; the resort may still report the
  // percentage open, so that stat is driven off `openPercent` rather than
  // a count we don't have (see util/openCount).
  const percentOpen = runsOpenPercent(fullResort.runs);

  if (!hasLifts && !hasRuns) return null;

  return (
    <section>
      <MiniSectionHeading title={t('resort.skiReport.liftsTerrain')} />
      <div className="border-b border-border" />
      <div className="grid grid-cols-2 gap-y-5 py-5 sm:grid-cols-4">
        {hasLifts && (
          <StatBlock
            label={t('resort.skiReport.liftOpen')}
            value={openCountText(fullResort.lifts, dash)}
          />
        )}
        {hasRuns && (
          <StatBlock
            label={t('resort.skiReport.runsOpen')}
            value={openCountText(fullResort.runs, dash)}
          />
        )}
        {hasAcres && (
          <StatBlock
            label={t('resort.skiReport.acresOpen')}
            value={fullResort.terrain!.acres!.open!}
          />
        )}
        {percentOpen !== undefined && (
          <StatBlock
            label={t('resort.skiReport.percentOpen')}
            value={percentOpen}
            unit="%"
          />
        )}
      </div>
      <div className="border-b border-border" />
    </section>
  );
};
